import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import authReducer from './slices/authSlice';
import loadingOverlayReducer from './slices/loadingOverlaySlice';
import mockDataReducer from './slices/mockDataSlice';
import auditTrailReducer from './slices/auditTrailSlice';

// Persist config for mockData slice only
const mockDataPersistConfig = {
  key: 'mock-user',
  storage,
};

const rootReducer = combineReducers({
  auth: authReducer,
  loadingOverlay: loadingOverlayReducer,
  mockData: persistReducer(mockDataPersistConfig, mockDataReducer),
  auditTrail: auditTrailReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;


